// src/store/slices/authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { auth } from "../../types";
// import { setUserAttributes } from "src/analytics";

// Initial state for the auth slice
const initialState: auth.AuthStateType = {
  patient: {
    data: null,
    isLoading: false,
    error: null,
    platform: "ios",
  },
  loginPatient: {
    data: null,
    isLoading: false,
    error: null,
  },
  updateProfile: {
    data: null,
    isLoading: false,
    error: null,
  },
};

// Define the auth slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // get patient details
    getPatientDetailsRequest: (
      state: auth.AuthStateType,
      action: PayloadAction<any>
    ) => {
      state.patient.isLoading = true;
      state.patient.data = null;
      state.patient.error = null;
    },
    getPatientDetailsSuccess: (
      state: auth.AuthStateType,
      action: PayloadAction<any>
    ) => {
      state.patient.isLoading = false;
      state.patient.data = action.payload;
      // state.patient.data = { ...action.payload, paidUser: 1 };
      state.patient.error = null;
    },
    getPatientDetailsError: (
      state: auth.AuthStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.patient.isLoading = false;
      state.patient.data = null;
      state.patient.error = error;
    },

    // login patient
    loginPatientRequest: (
      state: auth.AuthStateType,
      action: PayloadAction<any>
    ) => {
      state.loginPatient.isLoading = true;
      state.loginPatient.data = null;
      state.loginPatient.error = null;
    },

    loginPatientSuccess: (
      state: auth.AuthStateType,
      action: PayloadAction<any>
    ) => {
      state.loginPatient.isLoading = false;
      state.loginPatient.data = action.payload;
      state.loginPatient.error = null;
    },

    loginPatientError: (
      state: auth.AuthStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.loginPatient.isLoading = false;
      state.loginPatient.data = null;
      state.loginPatient.error = error;
    },

    // update profile
    updateProfileRequest: (
      state: auth.AuthStateType,
      action: PayloadAction<any>
    ) => {
      state.updateProfile.isLoading = true;
      state.updateProfile.data = null;
      state.updateProfile.error = null;
    },
    updateProfileSuccess: (
      state: auth.AuthStateType,
      action: PayloadAction<any>
    ) => {
      state.updateProfile.isLoading = false;
      state.updateProfile.data = action.payload;
      state.patient.data = action.payload;
      state.updateProfile.error = null;
    },
    updateProfileError: (
      state: auth.AuthStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.updateProfile.isLoading = false;
      state.updateProfile.data = null;
      state.updateProfile.error = error;
    },
  },
});

// Export actions and reducer
export const {
  // get patient details
  getPatientDetailsRequest,
  getPatientDetailsSuccess,
  getPatientDetailsError,

  // login patient
  loginPatientRequest,
  loginPatientSuccess,
  loginPatientError,

  // update profile
  updateProfileRequest,
  updateProfileSuccess,
  updateProfileError,
} = authSlice.actions;

export default authSlice.reducer;
